import { differenceInHours, formatDistanceStrict } from "date-fns";

import { CaseQAReview } from "pwapi";

export const getTimeDifference = (date: Date, hasSuffix?: boolean) => {
  const hoursDifference = differenceInHours(date, new Date());
  if (Math.abs(hoursDifference) >= 1 && Math.abs(hoursDifference) <= 72) {
    return `${Math.abs(hoursDifference)} hours${
      hoursDifference > 0 ? "" : " ago"
    }`;
  } else {
    return formatDistanceStrict(date, new Date(), { addSuffix: hasSuffix });
  }
};

export const getMostRecentQAReview = (qaReviews?: CaseQAReview[]) =>
  qaReviews &&
  qaReviews.reduce(
    (a, b) => ((a.created_at || "") > (b.created_at || "") ? a : b),
    {} as CaseQAReview
  );

export const extractBasePathname = (pathname: string): string =>
  `${pathname}${pathname.endsWith("/") ? "" : "/"}`;
